import { Directive, ElementRef } from '@angular/core';

import { LocaleDataService } from '../services';
import { Locale } from '../models';

@Directive({
  selector: '[atnCurrentLocaleCode]',
  host: {
    '[style.fontSize]': '".5rem"',
    '[style.textTransform]': '"uppercase"',
  }
})
export class CurrentLocaleCodeDirective {

  locale: Locale;

  constructor(
    private ref: ElementRef,
    private localeDataService: LocaleDataService
  ) {
    console.log(this.localeDataService.getCurrentLocale())
    this.ref.nativeElement.textContent = this.localeDataService.getCurrentLocale().code;
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/core/directives/current-locale-code.directive.ts